import { WeatherData } from "../types/weather-types";

export const fetchWeatherForLocation = async (
  latitude: number,
  longitude: number
): Promise<WeatherData> => {
  const response = await fetch(
    `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&hourly=temperature_2m,weathercode`
  );

  // Check if the response is ok (status code 200)
  if (!response.ok) {
    throw new Error("Failed to fetch weather data");
  }

  const data = await response.json();
  console.log(data);

  // Extract the required fields from the response
  const hourlyData = data.hourly; // Extract the hourly data

  return {
    weathercode: hourlyData.weathercode[0], // Get the first weather code (optional if you want to keep it)
    temperature: hourlyData.temperature_2m[0], // Get the first temperature
    elevation: data.elevation, // Include elevation from the API response
    latitude: data.latitude, // Include latitude from the API response
    longitude: data.longitude, // Include longitude from the API response
    timezone: data.timezone, // Include timezone from the API response
    timezone_abbreviation: data.timezone_abbreviation, // Include timezone abbreviation
    utc_offset_seconds: data.utc_offset_seconds, // Include UTC offset in seconds
    generationtime_ms: data.generationtime_ms, // Include generation time in milliseconds
    hourly: {
      time: hourlyData.time, // Include array of time strings
      temperature_2m: hourlyData.temperature_2m, // Include temperature array
      weathercode: hourlyData.weathercode, // Include weather code array
    },
    hourly_units: {
      time: "iso8601", // Specify time units
      temperature_2m: "°C", // Specify temperature units
      weathercode: "weathercode", // Optional: specify unit for weather code if necessary
    },
  };
};
